import ChatBox from "./ChatBox";
import Drawer from "./Drawer";
import Footer from "./Footer";
import VisualAudio from "./VisualAudio";
import { useAppSelector } from "../store/hooks";
import "./Home.css";

const Home = () => {
  const isRecording = useAppSelector((state) => state.chat.isRecord);
  const showDrawer = useAppSelector((state) => state.chat.showDrawer);
  const showBg = useAppSelector((state) => state.chat.showBg);

  return (
    <>
      <div className={`audio ${isRecording ? "expand" : ""}`}>
        <VisualAudio />
      </div>
      <div className={`main-body ${isRecording ? "fade-out" : ""}`}>
        <ChatBox />
      </div>
      <div className={`footer ${isRecording ? "fade-out" : ""} ${showDrawer ? "drawer-open" : ""}`}>
        <Footer />
      </div>
      {showDrawer || showBg ? <div className="global-dim-overlay" /> : null}
      {showDrawer ? (
        <div className="drawer">
          <Drawer />
        </div>
      ) : null}
    </>
  );
};

export default Home;
